const visibleWidth = ({
  xsmall: '100vw',
  small: '100vw',
  medium: '80vw',
  large: '70vw',
  xlarge: '55vw'
});

export default visibleWidth;
